import React from 'react';

function AnalysisSvg() {
	return (
		<svg
			fill="#000000"
			version="1.1"
			id="Capa_1"
			xmlns="http://www.w3.org/2000/svg"
			width="60pt"
			height="60pt"
			viewBox="0 0 101.38 101.379"
		>
			<g>
				<g>
					<path
						d="M100.622,70.318L80.839,50.535c6.242-8.051,5.687-19.706-1.703-27.095c-8.01-8.01-21.044-8.01-29.054,0
               c-8.01,8.011-8.01,21.044,0,29.055c7.389,7.389,19.043,7.944,27.095,1.703L96.96,73.98c1.013,1.012,2.651,1.012,3.662,0.001
               C101.633,72.969,101.633,71.331,100.622,70.318z M75.473,48.832c-5.99,5.991-15.738,5.992-21.729,0
               c-5.991-5.99-5.991-15.738,0-21.729c5.99-5.99,15.738-5.992,21.729,0C81.464,33.093,81.464,42.841,75.473,48.832z"
					/>
					<path
						d="M5,66.071V12.403h89v48.086l5,5V11.903c0-2.48-2.02-4.5-4.5-4.5h-90c-2.481,0-4.5,2.02-4.5,4.5v54.668
               c0,2.48,2.019,4.5,4.5,4.5h36.012v14.254c0,1.721,1.398,3.119,3.117,3.119h9.741c1.719,0,3.116-1.398,3.116-3.119V71.071H91.6
               l-5-5H5z M43.629,85.325V71.071h9.741l0.002,14.256L43.629,85.325z"
					/>
					<path
						d="M64.49,82.077v3c-0.213,0-0.387-0.174-0.387-0.387v6.287H32.896V84.69c0,0.213-0.174,0.387-0.387,0.387v-3
               c-1.441,0-2.613,1.172-2.613,2.613v6.674c0,1.441,1.172,2.613,2.613,2.613H64.49c1.441,0,2.613-1.172,2.613-2.613V84.69
               C67.104,83.249,65.932,82.077,64.49,82.077z"
					/>
					<path
						d="M38.279,60.799h7.656c0.312,0,0.564-0.252,0.564-0.563v-9.399c-1.578-2.267-2.687-4.754-3.337-7.341l-5.448,5.67v11.071
               C37.714,60.547,37.967,60.799,38.279,60.799z"
					/>
					<path
						d="M59.613,60.799c0.312,0,0.565-0.252,0.565-0.563v-0.264c-3.19-0.687-6.173-2.064-8.785-4.048v4.312
               c0,0.312,0.253,0.563,0.564,0.563H59.613z"
					/>
					<path d="M59.613,47.749h-3.711c1.26,1.172,2.707,2.076,4.276,2.68v-2.114C60.179,48.002,59.926,47.749,59.613,47.749z" />
					<path
						d="M72.541,60.799c0.312,0,0.564-0.252,0.564-0.563v-1.269c-2.582,0.996-5.349,1.524-8.142,1.524
               c-0.2,0-0.396-0.022-0.593-0.028c0.088,0.197,0.283,0.336,0.514,0.336H72.541z"
					/>
					<path
						d="M72.061,36.082c-0.48,0-0.949-0.17-1.317-0.478l-1.392-1.163L64.32,39.93v11.363c0.222,0.011,0.441,0.031,0.666,0.031
               c2.98,0,5.801-0.978,8.119-2.758V35.791c-0.031,0.019-0.06,0.04-0.092,0.058C72.721,36.001,72.391,36.082,72.061,36.082z"
					/>
					<path
						d="M57.697,44.815l11.611-12.667l2.717,2.271c0.133,0.11,0.319,0.131,0.473,0.051c0.152-0.08,0.242-0.244,0.229-0.417
               l-0.59-6.585c-0.021-0.235-0.229-0.409-0.463-0.388l-6.585,0.589c-0.172,0.016-0.317,0.133-0.37,0.298
               c-0.017,0.055-0.021,0.11-0.018,0.166c0.01,0.11,0.062,0.216,0.152,0.289l2.721,2.275L56.544,42.73L52,41.058
               c0.227,0.96,0.557,1.888,0.986,2.77l3.488,1.283C56.906,45.269,57.389,45.153,57.697,44.815z"
					/>
					<path
						d="M42.486,38.646l-7.456,7.76c-0.433,0.45-0.418,1.165,0.032,1.597c0.219,0.211,0.501,0.315,0.782,0.315
               c0.297,0,0.593-0.116,0.814-0.347l6.112-6.36C42.61,40.628,42.516,39.638,42.486,38.646z"
					/>
				</g>
			</g>
		</svg>
	);
}

export default AnalysisSvg;
